<div
  class="{{ alertType }} alert-custom alert-dismissible fade show"
  *ngIf="alertMessage"
  role="alert"
>
  <span style="margin-right: 10px;">{{ alertMessage }}</span>
  <button
    type="button"
    class="btn-close p-3"
    data-bs-dismiss="alert"
    aria-label="Close"
    (click)="cerrarAlerta()"
  ></button>
</div>